import { __ } from '@wordpress/i18n';
import { noop } from '@wp-g2/utils';
import React from 'react';
import { ControlLabel } from '../ControlLabel';
import { Grid } from '../Grid';
import { Slider } from '../Slider';
import { TextInput } from '../TextInput';
import { VStack } from '../VStack';
import { getSliderTemplateColumns } from './font-size-control-utils';

function FontSizeControlSlider(props) {
  var _props$label = props.label,
      label = _props$label === void 0 ? __('Custom size') : _props$label,
      disabled = props.disabled,
      min = props.min,
      max = props.max,
      _props$onChange = props.onChange,
      onChange = _props$onChange === void 0 ? noop : _props$onChange,
      size = props.size,
      value = props.value,
      withSlider = props.withSlider;
  if (!withSlider) return null;
  var templateColumns = getSliderTemplateColumns();
  var controlProps = {
    disabled: disabled,
    min: min,
    max: max,
    onChange: onChange,
    size: size,
    value: value
  };
  return /*#__PURE__*/React.createElement(VStack, {
    spacing: 0
  }, /*#__PURE__*/React.createElement(ControlLabel, null, label), /*#__PURE__*/React.createElement(Grid, {
    templateColumns: templateColumns
  }, /*#__PURE__*/React.createElement(Slider, controlProps), /*#__PURE__*/React.createElement(TextInput, Object.assign({}, controlProps, {
    type: "number"
  }))));
}

export default FontSizeControlSlider;